import apiFactory from '../../services/apiFactory';
import { identifyDevice, trackEvent } from '../../utils/mixpanelUtil';

export const getPastOrders = (vendor_id) => {
  return new Promise((resolve, reject) => {
    apiFactory.get(`orders?vendor_id=${vendor_id}`).then(
      ({ data }) => {
        identifyDevice();
        trackEvent('Load order details', {
          action_category: 'Load Screen',
          action_outcome: 'success',
          interaction_element: 'Screen',
          source: 'sf_web'
        });
        resolve(data.orders.data);
      },
      (error) => {
        identifyDevice();
        trackEvent('Orders', {
          action_category: 'Retrieve Orders',
          action_outcome: 'fail',
          interaction_element: 'Screen',
          source: 'sf_web'
        });
        reject(error);
      }
    );
  });
};

export const changeOrderStatus = (orderId, status) => {
  return new Promise((resolve, reject) => {
    apiFactory
      .post('/orders/update_status', {
        order_id: orderId,
        status: status
      })
      .then(
        (response) => {
          identifyDevice();
          trackEvent('changeOrderStatus', {
            action_category: 'Update Order',
            action_outcome: 'success',
            interaction_element: 'Screen',
            source: 'sf_web'
          });
          resolve(response);
        },
        (error) => {
          identifyDevice();
          trackEvent('changeOrderStatus', {
            action_category: 'Update Order',
            action_outcome: 'fail',
            interaction_element: 'Screen',
            source: 'sf_web'
          });
          reject(error);
        }
      );
  });
};

export const getOrderDetail = (id) => {
  return new Promise((resolve, reject) => {
    apiFactory.get(`orders/${id}`).then(
      ({ data }) => {
        identifyDevice();
        trackEvent('Load order details', {
          action_category: 'Load Screen',
          action_outcome: 'success',
          interaction_element: 'Screen',
          source: 'sf_web'
        });
        resolve(data.order);
      },
      (error) => {
        identifyDevice();
        trackEvent('Orders', {
          action_category: 'Retrieve Orders',
          action_outcome: 'fail',
          interaction_element: 'Screen',
          source: 'sf_web'
        });
        reject(error);
      }
    );
  });
};

export const getOrders = (page = 1, perPage = 15, filterKeys, orderBy, orderDirection) => {
  const params = [`page=${page}`, `per_page=${perPage}`];
  if (orderBy) {
    params.push(`ordering_attribute=${orderBy}`);
    params.push(`ordering_order=${orderDirection}`);
  }

  if (!!filterKeys && filterKeys.length > 0) {
    for (let i = 0; i < filterKeys.length; i++) {
      params.push(filterKeys[i]);
    }
  }

  return new Promise((resolve, reject) => {
    apiFactory.get(`orders?${params.join('&')}`).then(
      ({ data }) => {
        identifyDevice();
        trackEvent('Load Orders', {
          action_category: 'Load Screen',
          action_outcome: 'success',
          interaction_element: 'Screen',
          source: 'sf_web'
        });
        resolve(data.orders);
      },
      (error) => {
        identifyDevice();
        trackEvent('Orders', {
          action_category: 'Retrieve Orders',
          action_outcome: 'fail',
          interaction_element: 'Screen',
          source: 'sf_web'
        });
        reject(error);
      }
    );
  });
};
